
import { DOASSIGNVARIANTS_TYPES } from '../actions/doAssignVariants'
import reducer, { defaultState } from './requests'
const Reducer = (state = defaultState, action) => {
    let requestReducer = reducer(DOASSIGNVARIANTS_TYPES)(state, action)
    if (requestReducer !== null) return requestReducer
    switch (action.type) {
        default:
            return state
    }
}
export default Reducer